import { QuestionCircleOutlined } from "@ant-design/icons"
import { type MenuItemType } from "components/Menu/Menu"
import { useRightSidebar } from "hooks/useRightSidebar"
import { useFlag } from "modules/flags/flags"
import { useMemo } from "react"

export function useHelpMenuOption() {
	const { setSidebarState } = useRightSidebar()
	const { helpDocsEmbed } = useFlag("helpDocsEmbed")
	const helpDocItem = useMemo(() => {
		const helpDocItem: MenuItemType = {
			key: "help-documentation",
			icon: <QuestionCircleOutlined aria-hidden />,
		}

		if (helpDocsEmbed.enabled) {
			helpDocItem.label = "Help documentation"
			helpDocItem.onClick = () => setSidebarState({ key: "help" })
		} else {
			helpDocItem.label = (
				<a
					href="https://support.empohealth.com"
					target="_blank"
					rel="noopener noreferrer"
				>
					Help documentation
				</a>
			)
		}

		return helpDocItem
	}, [helpDocsEmbed.enabled, setSidebarState])

	return helpDocItem
}
